import { FormField, Radio, RadioCell, UIText1, UIText2 } from '@cian/ui-kit';
import React from 'react';

import { IField } from '../../types/calculator';
import { useBaseField } from '../BaseField';
import styles from './styles.css';

export const RadioField: React.FC<IField> = props => {
  const { field, fieldState } = useBaseField(props);

  if (!props.source) {
    return null;
  }

  const isError = fieldState.isDirty || fieldState.invalid;
  const isRadioCellVariant = props.variant === 'radioCell';

  return (
    <FormField
      label={props.label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <div className={isRadioCellVariant ? styles['cell-wrapper'] : styles.wrapper}>
        {props.source.map(option =>
          isRadioCellVariant ? (
            <div key={option.value}>
              <RadioCell
                title={option.label}
                description={option.description}
                data-testid={`${props.name} ${option.value}`}
                name={props.name}
                value={option.value}
                onChange={e => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                checked={option.value === field.value}
                disabled={props.disabled || option.disabled}
                ref={field.ref}
              />
            </div>
          ) : (
            <div key={option.value} className={styles.radio}>
              <Radio
                indicatorPosition="top"
                label={
                  <>
                    <UIText1 color="text-primary-default">{option.label}</UIText1>
                    <UIText2 color="current_color">{option.description}</UIText2>
                  </>
                }
                data-testid={`${props.name} ${option.value}`}
                name={props.name}
                value={option.value}
                onChange={e => field.onChange(e.target.value)}
                onBlur={field.onBlur}
                checked={option.value === field.value}
                disabled={props.disabled || option.disabled}
                ref={field.ref}
              />
            </div>
          ),
        )}
      </div>
    </FormField>
  );
};

RadioField.displayName = 'RadioField';
